import { Link, useLocation } from 'react-router'
import { ADMIN_SECTIONS, adminSection } from './adminSections'

/** One link per admin section. They share a path, so the active one is picked from `?tab=`
 * (an account's, crash's or conversation's page counts as its section). */
export function AdminNavLinks() {
	const { pathname, search } = useLocation()
	const current = pathname.startsWith('/admin/accounts/')
		? 'accounts'
		: pathname.startsWith('/admin/crashes/')
			? 'crashes'
			: pathname.startsWith('/admin/support/')
				? 'support'
				: pathname === '/admin'
					? adminSection(new URLSearchParams(search).get('tab'))
					: null
	return ADMIN_SECTIONS.map((s) => (
		<Link
			key={s.value}
			to={`/admin?tab=${s.value}`}
			className={s.value === current ? 'active' : undefined}
			aria-current={s.value === current ? 'page' : undefined}
		>
			{s.label}
		</Link>
	))
}
